import {z} from "zod/v4-mini"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"

export const fixedValueNodeDefinition = <ValueType>(nodeClass: string, valueSchema: z.ZodMiniType<ValueType, ValueType>) =>
    ({
        label: "Fixed Value Node",
        nodeClass,
        validation: {
            parameters: z.object({value: valueSchema}),
            returns: valueSchema,
        },
    }) satisfies GraphNodeDefinition<ValueType, {value: ValueType}>
